<div class="allocate-trade">
  <form [formGroup]="form">
    <div class="allocate-trade__row">
      <span class="allocate-trade__row__field-text">
        <span class="allocate-trade__row__field-text__current-counter-party">
          Current counter party A: {{ selectedTrade.counterPartyA }}
        </span>
      </span>
      <div class="clr-select-wrapper allocate-trade__row__field-text">
        Replace with
        <select class="clr-select" formControlName="counterPartyA">
          <option
            *ngFor="let counterParty of counterParties"
            [value]="counterParty"
          >
            {{ counterParty }}
          </option>
        </select>
      </div>
      <span class="allocate-trade__row__field-text">
        <span class="allocate-trade__row__field-text__current-counter-party">
          Current counter party B: {{ selectedTrade.counterPartyB }}
        </span>
      </span>
      <div class="clr-select-wrapper allocate-trade__row__field-text">
        Replace with
        <select class="clr-select" formControlName="counterPartyB">
          <option
            *ngFor="let counterParty of counterParties"
            [value]="counterParty"
          >
            {{ counterParty }}
          </option>
        </select>
        <span
          *ngIf="form.errors?.invalidCounterParty"
          class="allocate-trade__row__error"
        >
          <a
            role="tooltip"
            aria-haspopup="true"
            class="tooltip tooltip-md tooltip-bottom-left"
          >
            <cds-icon shape="error-standard" class="is-error"></cds-icon>
            <span class="tooltip-content" aria-haspopup="true">{{
              form.errors.invalidCounterParty.value
            }}</span>
          </a>
        </span>
      </div>
    </div>

    <div class="allocate-trade__row">
      <span class="allocate-trade__row__field-text">Split according to</span>
      <div class="clr-select-wrapper">
        <select
          class="clr-select"
          formControlName="splitAccordinglyTo"
          (change)="changeInAmountShortName()"
        >
          <option
            *ngFor="let value of splitAccordinglyToValues"
            [value]="value"
          >
            {{ value }}
          </option>
        </select>
      </div>
      <span class="allocate-trade__row__field-text">Split method</span>
      <div class="clr-select-wrapper">
        <select class="clr-select" formControlName="splitMethod">
          <option *ngFor="let value of splitMethods" [value]="value">
            {{ value }}
          </option>
        </select>
      </div>
      <span class="allocate-trade__row__field-text">Split related trades</span>

      <clr-checkbox-wrapper>
        <input
          type="checkbox"
          formControlName="splitRelatedTrades"
          clrCheckbox
        />
      </clr-checkbox-wrapper>
    </div>

    <div
      class="allocate-trade__row allocate-trade__row--table scrollable-content scrollable-content--hover"
    >
      <div
        class="allocate-trade__row__table-group"
        *ngFor="let table of allocationTablesControls; index as tableIndex"
      >
        <div
          class="allocate-trade__row__table-group__table-title"
          *ngIf="createResponse"
        >
          {{
            createResponse.allocationDetails[
              createResponse.relatedTrades[tableIndex].tradeId
            ]?.tradeName
          }}
        </div>
        <div class="allocate-trade__row__table-group__table">
          <div #divToScroll class="table-container scrollable-content">
            <ng-container formArrayName="allocations">
              <ng-container [formArrayName]="tableIndex">
                <table ui-table id="table">
                  <thead>
                    <tr>
                      <ng-container *ngIf="!tableIndex">
                        <th *ngFor="let allocation of eligibleAllocations">
                          {{ allocation.key }}
                        </th>
                      </ng-container>
                      <th class="amount" *ngIf="!createResponse">
                        {{ form.get('splitAccordinglyTo').value }}
                        ({{
                          formatHeaderDecimal(
                            expectedSums[tableIndex][splitAmountShortName].sum
                          )
                        }})
                      </th>
                      <ng-container *ngIf="createResponse?.headers">
                        <ng-container
                          *ngFor="let header of createResponse.headers"
                        >
                          <th
                            *ngIf="expectedSums[tableIndex][header.shortName]"
                            [class]="header.shortName"
                          >
                            {{ header.longName }}
                            ({{
                              header.format === 'formattedDecimal'
                                ? formatHeaderDecimal(
                                    expectedSums[tableIndex][header.shortName]
                                      .sum,
                                    header
                                  )
                                : expectedSums[tableIndex][header.shortName]
                                    .sum
                            }})
                          </th>
                        </ng-container>
                      </ng-container>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let control of table.controls; index as i"
                      [ngClass]="{ selected: selectedRowIndex === i }"
                      (click)="selectedRowIndex = i"
                    >
                      <ng-container [formGroupName]="i">
                        <ng-container *ngIf="!tableIndex">
                          <td *ngFor="let allocation of eligibleAllocations">
                            <ng-select
                              [items]="allocation.values"
                              [searchable]="true"
                              class="input-field"
                              appendTo="body"
                              [clearable]="false"
                              (paste)="
                                onPaste($event, i, allocation.key, tableIndex)
                              "
                              [formControlName]="allocation.key"
                            >
                            </ng-select>
                          </td>
                        </ng-container>
                        <td *ngIf="!createResponse">
                          <input
                            type="text"
                            class="input-field"
                            autocomplete="off"
                            [formControl]="
                              $any(
                                allocationTablesControls[tableIndex].controls[
                                  i
                                ].get(splitAmountShortName)
                              )
                            "
                            [inputValidator]="['negativeNumericShorthand']"
                            (input)="
                              calculateFieldSum(
                                splitAmountShortName,
                                tableIndex
                              )
                            "
                            (paste)="
                              onPaste(
                                $event,
                                i,
                                splitAmountShortName,
                                tableIndex
                              )
                            "
                          />
                        </td>
                        <ng-container *ngIf="createResponse?.headers">
                          <ng-container
                            *ngFor="let header of createResponse.headers"
                          >
                            <td
                              *ngIf="expectedSums[tableIndex][header.shortName]"
                            >
                              <input
                                type="text"
                                class="input-field"
                                autocomplete="off"
                                (input)="
                                  calculateFieldSum(
                                    header.shortName,
                                    tableIndex
                                  )
                                "
                                (blur)="
                                  formatFieldOnBlur(
                                    header,
                                    $any($event.target).value,
                                    $any(control.get(header.shortName))
                                  )
                                "
                                [inputValidator]="
                                  FieldValidators(header.format)
                                "
                                [formControl]="
                                  $any(
                                    allocationTablesControls[
                                      tableIndex
                                    ].controls[i].get(header.shortName)
                                  )
                                "
                                (paste)="
                                  onPaste(
                                    $event,
                                    i,
                                    header.shortName,
                                    tableIndex
                                  )
                                "
                              />
                            </td>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </tr>
                  </tbody>
                </table>
              </ng-container>
            </ng-container>
          </div>
          <div class="bottom-table-add" *ngIf="!tableIndex">
            <span class="add-text-container"
              ><label class="add-text-container__add-label">+</label>
              <label class="add-text" (click)="addAllocation()"
                >Add allocation</label
              ></span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="allocate-trade__row__table-group__table-footer">
      <button
        type="button"
        class="ui-button ui-button__footer"
        (click)="previewAllocations()"
        [disabled]="previewAllocationsDisabled"
      >
        <ng-container
          *ngIf="
            previewState === '' || previewState === done;
            else previewAllocationLoading
          "
        >
          Preview Allocations
        </ng-container>

        <ng-template #previewAllocationLoading>
          <span class="spinner spinner-sm spinner-inverse"> </span>
        </ng-template>
      </button>

      <button
        type="button"
        class="ui-button ui-button__footer ui-button--delete ui-button--danger"
        (click)="removeAllocations()"
        [disabled]="selectedRowIndex == null"
      >
        Remove Selected Allocations
      </button>
    </div>

    <div class="allocate-trade__row allocate-trade__row--messages">
      <span
        class="allocate-trade__row--messages__message allocate-trade__row--messages__message--state"
        *ngIf="state.message"
      >
        {{ state.message }}
      </span>
      <ng-container *ngFor="let table of expectedSums; index as tableIndex">
        <ng-container *ngFor="let field of table | keyvalue">
          <span
            *ngIf="
              field.value.expectedSum !== field.value.sum &&
              (firstAllocationsLength || previewState === done)
            "
            class="allocate-trade__row--messages__message"
            [ngClass]="
              strictAllocations[field.key] === false
                ? 'allocate-trade__row--messages__message--warning'
                : 'allocate-trade__row--messages__message--error'
            "
          >
            <b>Table {{ tableIndex + 1 }} </b>
            {{
              previewState === done
                ? shortNameToLongName(field.key)
                : splitAccordingTo
            }}
            sum expected to be
            {{ formatNumberFromField(field.key, field.value.expectedSum) }}.

            <ng-container
              *ngIf="
                strictAllocations[field.key] !== false;
                else showDifference
              "
            >
              {{
                field.value.expectedSum - field.value.sum > 0
                  ? 'An increase'
                  : 'A reduction'
              }}
              of
              {{ sumDiff(field.value) }}

              is required.
            </ng-container>

            <ng-template #showDifference>
              Currently
              {{ formatNumberFromField(field.key, field.value.sum) }} (diff:
              {{ sumDiff(field.value) }}).
            </ng-template>
          </span>
        </ng-container>
      </ng-container>
    </div>

    <div class="allocate-trade__footer">
      <button
        *ngIf="saveState !== done; else allocationsSaved"
        type="button"
        class="ui-button ui-button primary"
        [disabled]="invalidTables || saveState !== '' || previewState !== done"
        (click)="saveAllocations()"
      >
        <ng-container *ngIf="saveState !== loading; else saveAllocationLoading">
          Save Allocations
        </ng-container>

        <ng-template #saveAllocationLoading>
          <span class="spinner spinner-sm spinner-inverse"> </span>
        </ng-template>
      </button>

      <ng-template #allocationsSaved>
        <span class="allocate-trade__footer__allocations-saved">
          Allocations Saved
        </span>
      </ng-template>

      <button type="button" class="ui-button ui-button" (click)="goBack()">
        Back
      </button>
    </div>
  </form>
</div>
